import request from '@/utils/request'

// 企业资讯列表(首页无权限)
export function steelExamineNoAuthList(query) {
    return request({
        url: '/business/document/dataFormSteelFactory/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯列表
export function examineList(query) {
    return request({
        url: '/business/document/dataFormSteelFactory/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯详情
export function examineDetail(query) {
    return request({
        url: '/business/document/dataFormSteelFactory/examineList',
        method: 'get',
        params: query
    })
}

// 企业资讯详情折线图
export function examineDetailEcharts(query) {
    return request({
        url: '/business/document/dataFormSteelFactory/getLineChartList',
        method: 'get',
        params: query
    })
}

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/business/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态二级页
export function industryPage(query) {
    return request({
        url: `/business/industry/steelList`,
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/business/industry/ironstoneSteelInfo/${id}`,
        method: 'get',
    })
}

// 后两个产量详情
export function backTwoYieldDetail(id) {
    return request({
        url: `/business/industry/steelYieldInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function steelReportNoAuthList(query) {
    return request({
        url: '/business/report/noAuth/List',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportPage(query) {
    return request({
        url: `/business/report/steelList`,
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function steelReportDetail(id) {
    return request({
        url: `/business/report/steelInfo/${id}`,
        method: 'get',
    })
}

// 技术与标准列表
export function standardPage(query) {
    return request({
        url: `/business/report/steelTechnicalList`,
        method: 'get',
        params: query
    })
}

// 技术与标准详情
export function standardDetail(id) {
    return request({
        url: `/business/report/steelTechnicalInfo/${id}`,
        method: 'get',
    })
}

// 价格列表(首页无权限)
export function steelPriceNoAuthList(query) {
    return request({
        url: '/business/metatron/price/noAuth/steelList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/business/metatron/price/steelList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/business/metatron/price/detailsSteelList',
        method: 'get',
        params: query
    })
}

// 库存列表(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/business/metatron/stock/noAuth/steelList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/business/metatron/stock/steelList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/business/metatron/stock/detailsSteelList',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/business/metatron/exit/steelList',
        method: 'get',
        params: query
    })
}

// 进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/business/metatron/exit/noAuth/steelList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/business/metatron/exit/detailsSteelList',
        method: 'get',
        params: query
    })
}

// 产量列表(前两个)
export function yieldPage(query) {
    return request({
        url: '/business/metatron/yield/yieldList',
        method: 'get',
        params: query
    })
}

// 产量列表（后两个）
export function yieldLastTwoPage(query) {
    return request({
        url: '/business/industry/steelInternationalList',
        method: 'get',
        params: query
    })
}

// 产量列表(首页无权限)
export function steelYieldNoAuthList(query) {
    return request({
        url: '/business/metatron/yield/noAuth/yieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(query) {
    return request({
        url: '/business/metatron/yield/detailsYieldList',
        method: 'get',
        params: query
    })
}


// 分省产量列表
export function cokeYieldPage(query) {
    return request({
        url: '/business/metatron/yield/cokeGroupProvinceList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function cokeYieldDetail(query) {
    return request({
        url: '/business/metatron/yield/detailsCokeYieldGroupProvinceList',
        method: 'get',
        params: query
    })
}

// 地图
export function mapData(query) {
    return request({
        url: '/business/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 五大品种合计产量
export function getDetailsYieldList(query) {
    return request({
        url: '/business/metatron/yield/detailsYieldList',
        method: 'get',
        params: query
    })
}


// 粗钢/生铁产量分省
export function getDetailsYieldGroupProvinceList(query) {
    return request({
        url: '/business/metatron/yield/detailsYieldGroupProvinceList',
        method: 'get',
        params: query
    })
}
